<template>
  <div class="card-text">{{ displayValue }}</div>
</template>

<script>
import { formatSchedule } from "@peninsula/jobSchedule";

export default {
  name: "JobScheduleCardField",
  height: 16,
  props: {
    field: { type: Object, required: true },
    value: { type: Object, default: null },
  },
  computed: {
    displayValue() {
      return formatSchedule(this.value, this.field.timezone);
    },
  },
};
</script>
